import * as yup from 'yup'

type ValidationMessages = {
  email: {
    email: string
    required: string
  }
  password: {
    required: string
  }
}

export const createLoginSchema = ({ email, password }: ValidationMessages) => {
  return yup.object({
    email: yup.string().email(email.email).required(email.required),
    password: yup.string().required(password.required)
  })
}
